<template>
  <div class="">
    <page-header light dark-crumb title="Пользовательское соглашение" />
    <content-wrapper-block>
      <div class="agreement">
        <div class="agreement-text">
          <p>
            <b>1. ОБЩИЕ ПОЛОЖЕНИЯ</b><br />
            1.1 АО «ГК ОСНОВА» (далее — Администратор) предлагает Пользователям
            присоединиться к настоящему Пользовательскому соглашению (далее –
            Соглашение) на условиях, указанных в данном документе.<br />
            1.2 Настоящее Соглашение определяет условия использования Сайта.<br />
            1.3 Совершение любых действий по использованию Сайта является
            безусловным принятием (акцептом) Пользователем условий
            Соглашения.<br />
            1.4 Соглашение определяет:<br />
            - порядок использования Сайта;<br />
            - политику конфиденциальности в отношении сбора и обработки
            пользовательских данных при использовании Сайта.
          </p>

          <p>
            <b>2. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</b><br />
            <b>Персональные данные</b> - любая информация, относящаяся к прямо
            или косвенно определенному или определяемому физическому лицу
            (субъекту персональных данных).<br />
            <b>Администратор</b> - АО «ГК ОСНОВА», зарегистрированный по адресу:
            142702, Московская обл., город Видное, поселок городского типа
            Бутово, территория жилой комплекс Бутово-Парк, д. 18, пом. 59.<br />
            <b>Пользователь</b> – физическое лицо, намеревающееся принять
            Пользовательское соглашение или принявшее его, а также использующее
            Сайт посредством информационно-телекоммуникационной сети
            Интернет.<br />
            <b>Сайт</b> – это совокупность текстов, графических элементов,
            дизайна, изображений, программного кода, и иных результатов
            интеллектуальной деятельности, содержащихся в
            информационно-телекоммуникационной сети Интернет под доменным именем
            «zk-mainstreet.ru», а также его поддоменов.
          </p>

          <p>
            <b>3. УСЛОВИЯ ИСПОЛЬЗОВАНИЯ САЙТА</b><br />
            3.1 Использование Сайта означает, что Пользователь ознакомился и
            принимает Соглашение, изложенное на данной странице. Если
            Пользователь не ознакомился и (или) не принимает данные условия, то
            Пользователь обязан покинуть Сайт.<br />
            3.2 Администратор оставляет за собой право в любое время изменять
            условия Соглашения и рекомендует Пользователю регулярно
            просматривать его, чтобы знать обо всех изменениях. Продолжение
            использования Сайта после внесения Администратором изменений будет
            означать согласие Пользователя с измененными условиями.<br />
            3.3 Предоставление доступа к Сайту и возможности информационного
            взаимодействия с Пользователем посредством Сайта осуществляются
            Администратором исключительно в информационных целях.<br />
            3.4 Пользователь вправе в свободной форме и по своему усмотрению
            знакомиться с содержимым Сайта.<br />
            3.5 Пользователь вправе при обнаружении ошибок в работе Сайта или в
            размещенном на нем контенте сообщить об этом Администратору.<br />
            3.6 Пользователь подтверждает, что он является дееспособным и достиг
            возраста, необходимого в соответствии с законодательством Российской
            Федерации для совершения сделок, предусмотренных Соглашением.<br />
            3.7 Использование материалов Сайта без письменного согласия
            Администратора не допускается.<br />
            3.8 Использование общедоступных сведений или иной информации, доступ
            к которой не ограничен, разрешено при соблюдении установленных
            федеральными законами ограничений в отношении распространения такой
            информации.<br />
            3.9 Пользователь обязуется не предпринимать несанкционированные и
            (или) неправомерные действия в отношении Сайта, в том числе любые
            действия, направленные на нарушение работы Сайта или его
            компонентов.<br />
            3.10 Администратор вправе:<br />
            - изменять, дорабатывать и обновлять Сайт без согласия и уведомления
            Пользователя;<br />
            - устанавливать любые ограничения на использование Сайта;<br />
            - проводить профилактические работы, влекущие приостановление работы
            Сайта.
          </p>

          <p>
            <b>4. ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</b><br />
            4.1 В целях исполнения Соглашения в соответствии с требованиями,
            установленными Федеральным законом «О персональных данных» от
            27.07.2006 N 152-ФЗ, Администратор вправе собирать и обрабатывать
            персональные данные Пользователей и файлы cookies.<br />
            4.2 Порядок обработки и защита персональных данных Пользователей
            определяется настоящим Соглашением и Политикой обработки
            персональных данных, расположенной по адресу
            <a
              href="/Политика_обработки_персональных_данных.pdf"
              target="_blank"
              class="breakable-link"
              >https://zk-mainstreet.ru/Политика_обработки_персональных_данных.pdf</a
            >.<br />
            4.3 Администратор в отношении обработки персональных данных
            Пользователей выступает в роли оператора персональных данных - лицо,
            самостоятельно организующее и/или осуществляющее обработку
            персональных данных, а также определяющее цели обработки
            персональных данных, состав обрабатываемых персональных данных и
            конкретные действия (операции) с такими персональными данными.<br />
            4.4 При посещении Сайта Администратор собирает файлы cookies.
            Порядок обработки файлов cookies определяется Политикой
            использования Cookies, расположенной по адресу
            <a href="/cookie-policy" target="_blank"
              >https://zk-mainstreet.ru/cookie-policy</a
            >.
          </p>

          <p>
            <b>5. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</b><br />
            5.1 Администратор не несет ответственности за:<br />
            - невозможность использования Сайта по причинам, не зависящим от
            Администратора;<br />
            - убытки, причинённые в результате использования Сайта.<br />
            5.2 Соглашение регулируется и толкуется в соответствии с
            законодательством Российской Федерации. Вопросы, не урегулированные
            Соглашением, подлежат разрешению в соответствии с законодательством
            Российской Федерации.<br />
            5.3 Соглашение может быть изменено или дополнено Администратором без
            уведомления Пользователя. Новая редакция Соглашения вступает в силу
            с момента ее размещения на Сайте. Пользователь обязан своевременно
            знакомится с действующим Соглашением.<br />
            5.4 Действующая версия Соглашения размещена в открытом доступе на
            Сайте: https://zk-mainstreet.ru/agreement.
          </p>
        </div>
      </div>
    </content-wrapper-block>
  </div>
</template>

<script>
import ContentWrapperBlock from "@/components/blocks/ContentWrapperBlock";
import PageHeader from "@/components/elements/PageHeader";

export default {
  name: "UserAgreementPage",
  components: {
    PageHeader,
    ContentWrapperBlock,
  },
};
</script>

<style lang="scss" scoped>
.agreement-text {
  font-family: $font-family-rubik;
  font-size: 13px;
  p {
    font-family: Rubik;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0.03em;
    color: #18181b;
    margin: 16px 0;
  }
  a {
    all: unset;
    text-decoration: underline;
    cursor: pointer;
  }
  .breakable-link {
    word-break: break-all;
  }
}
.page-header {
  padding-bottom: 0;
}
</style>
